import { Component, Member } from '@paragon/contract-library';
import { assertExhaustiveSwitch } from '@paragon/utilities';

import { blocksFilter, chordsFilter, websFilter } from '../../../../store/selectors/assemblyPartsUtilities';

export type PartsFilterSelection = 'allMembers' | 'chords' | 'webs' | 'blocks' | 'other' | 'plates';

export type MemberFilter = (members: readonly Member[], component: Component) => readonly Member[];

export function getMemberFilter(filterSelection: PartsFilterSelection): MemberFilter | null {
  switch (filterSelection) {
    case 'allMembers':
      return (members) => members;
      break;
    case 'chords':
      return chordsFilter;
      break;
    case 'webs':
      return (members, component) => websFilter(members, component);
      break;
    case 'blocks':
      return (members, component) => blocksFilter(members, component);
      break;
    case 'other':
      return (members, component) => {
        const categorizedMembers = chordsFilter(members).concat(
          websFilter(members, component).concat(blocksFilter(members, component)),
        );
        return members.filter((member) => !categorizedMembers.includes(member));
      };
      break;
    case 'plates':
      return null;
      break;
    default:
      assertExhaustiveSwitch(filterSelection);
  }
}
